// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const FIN_NATUREZA_TITULO = {
  FaturaComercial: 'FIN_NATUREZA_TITULO1',
  ServicosLogisticos: 'FIN_NATUREZA_TITULO2',
  TributosETaxas: 'FIN_NATUREZA_TITULO3',
  OperacoesFinanceiras: 'FIN_NATUREZA_TITULO4',
  LancamentosManuais: 'FIN_NATUREZA_TITULO5',
  AcertoDeContas: 'FIN_NATUREZA_TITULO6',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    FIN_NATUREZA_TITULO1: 1,
    FIN_NATUREZA_TITULO2: 2,
    FIN_NATUREZA_TITULO3: 3,
    FIN_NATUREZA_TITULO4: 5,
    FIN_NATUREZA_TITULO5: 6,
    FIN_NATUREZA_TITULO6: 7
  }
}
